
export default class tdSupportChat {



    static isAttached = false;




    static hideChat() {
        console.log('tdSupportChat.hideChat()');
        if ( typeof Tawk_API !== "undefined" ) {
            if ( Tawk_API.hideWidget ) {
                Tawk_API.hideWidget();
            } else {
                Tawk_API.onLoad = function(){
                    Tawk_API.hideWidget();
                };
            }
        }
    }

    static showChat() {
        console.log('tdSupportChat.showChat()');

        if ( typeof Tawk_API !== "undefined" ) {
            if ( Tawk_API.showWidget ) {
                Tawk_API.showWidget();
            } else {
                Tawk_API.onLoad = function(){
                    Tawk_API.showWidget();
                };
            }
        }
    }

    /**
     *
     * @param language
     */
    static attachChat(language = 'ro_RO') {

        //return;

        if (tdSupportChat.isAttached === true) {
            console.log('%cERROR', 'background: #ffaa00; color: #ffffff; padding:3px 6px', 'tawk Chat already attached!');
            window.Tawk_API.showWidget(); //show chat

            //console.log ('tawk Chat already attached!');
            return;
        }

        tdSupportChat.isAttached = true;

        let tawkEmbedUrl = 'https://embed.tawk.to/5fe48eb1a8a254155ab61acf/1eqacqplm';
        if (language === 'ro_RO') {
            tawkEmbedUrl = 'https://embed.tawk.to/5d403c33e5ae967ef80d7f4d/default';
        }


        // show tawk only on desktop
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Electron/i.test(navigator.userAgent) === false) {


            //window.Tawk_API=Tawk_API||{};

            window.Tawk_LoadStart=new Date();
            (function(){
                var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
                s1.async=true;
                s1.src=tawkEmbedUrl;
                s1.charset='UTF-8';
                s1.setAttribute('crossorigin','*');
                s0.parentNode.insertBefore(s1,s0);
            })();
            window.onbeforeprint = function(event) {
                console.log("tawk hide 1");

                let tawkIframes = jQuery("iframe[title='chat widget']");
                let tawkIframesParent;
                if (tawkIframes.length > 0) {
                    tawkIframesParent = jQuery(tawkIframes[0]).parent();
                    tawkIframesParent.hide();
                    //console.log("test");
                }


                //console.log(tawkIframesParent);
                //jQuery("iframe[title='chat widget']").hide();
                //jQuery("iframe[title='chat widget']").attr('style','display:none !important');

                window.Tawk_API.hideWidget(); //hide chat
            };

            window.onafterprint = function(event) {
                console.log("tawk  show 1");

                let tawkIframes = jQuery("iframe[title='chat widget']");
                let tawkIframesParent;
                if (tawkIframes.length > 0) {
                    tawkIframesParent = jQuery(tawkIframes[0]).parent();
                    tawkIframesParent.show();
                    tawkIframesParent.attr('style','display:block !important');

                    //console.log("test");
                }

                //jQuery("iframe[title='chat widget']").show();
                //jQuery("iframe[title='chat widget']").attr('style','display:block !important');
                window.Tawk_API.showWidget(); //show chat
            };


            // hide tawk on print
            // var tdOnPrintMedia = window.matchMedia('print');
            // tdOnPrintMedia.addListener(function(mql) {
            //
            //     if(mql.matches) {
            //         console.log("tawk hide ");
            //         window.Tawk_API.hideWidget(); //hide chat
            //     } else {
            //         console.log("tawk  show");
            //         window.Tawk_API.showWidget(); //show chat
            //     }
            // });
        }
    }





}



// WEBPACK FOOTER //
// ./src/tdSupportChat.js